<div class="start-payroll" *ngIf="isLoading">
  <div class="wrap-progress-bar">
    <itax-progress-bar [hidden]="!isLoading"
                       [progress]="progress">
    </itax-progress-bar>
  </div>
</div>
<div *ngIf="isLoadingSpin">
  <div class="spinner-container">
    <div class="spinner-icon-container">
      <itax-spinner></itax-spinner>
    </div>
  </div>
</div>
<div class="start-payroll" *ngIf="!isLoading">
  <div class="wrapper">
    <div class="scroll-container" #scrollContainer>
      <div class="top d-flex">
        <div class="left-col">
          <div class="d-grid w-100 position-relative pr-10px pl-20px wrap-employees pb-40px">
            <itax-employee-list (valueChange)="onShowDetailValueChange($event)"
                                (showDetail)="onComeIn($event)"
                                [employeeList]="employeeList"
                                [employeeCurrent]="employeeCurrent"
                                [employeeOld]="employeeOld"
                                (onAddSelectedEmployeeToPayroll)="onAddSelectedEmployeeToPayroll($event)"
                                (removeFormCurrentList)="removeFormCurrentList($event)"
                                (removeFormCurrentListToOld)="removeFormCurrentListToOld($event)"
                                (onSetFilterEmployee)="onSetFilterEmployee($event)"
                                (onFilterChanged)="onFilterChanged($event)"
                                [monthSelected]="month"
                                [yearSelected]="year"
                                [page]="page"
                                [payrollId]="payrollId"
                                [totalEmployee]="totalEmployee">
            </itax-employee-list>
          </div>
          <div class="bottom-summary">
            <div class="total">
              <div class="d-grid">
                <div class="pb-10px font-weight-bold">
                  TOTAL (this page)
                </div>
                <div class="font-weight-normal d-flex align-items-center">
                  <div class="dot mr-10px"></div>
                  <div class="text-yellow">iTAX ไม่ได้คำนวณให้</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="x-scroll-col d-flex">
          <div class="position-relative" *ngIf="incomeColumnsHeader && incomeColumnsData?.length > 0">
            <div class="d-grid w-100 position-relative pr-10px pb-40px">
              <itax-income-list [incomeColumnsHeader]="incomeColumnsHeader"
                                [incomeColumnsData]="incomeColumnsData"
                                (addMoreColumn)="addMoreColumn($event)"
                                (onValueChanged)="onIncomeValueChanged($event)"
                                (onSetCopyLength)="onSetCopyLength($event)"
                                [timeUnitPriceHasChanged]="timeUnitPriceHasChanged"
                                [defaultColumns]="defaultColumns"
                                [defaultIncome]="defaultIncome"
                                [copyLength]="copyLength"
                                [isLoading]="isExcelLoading"
                                [requestNotiList]="requestNotiList"
                                [timeClockColumnList]="timeClockColumn.income"
                                [startRowIndex]="startRowIndex">
              </itax-income-list>
            </div>
            <div class="bottom-summary">
              <itax-footer-list [incomeColumns]="incomeFooter"
                                (onConfigChange)="onConfigFooterChanged($event)">
              </itax-footer-list>
            </div>
          </div>
          <div class="position-relative" *ngIf="expenditureColumnsHeader && expenditureColumnsData?.length > 0">
            <div class="d-grid w-100 position-relative pr-10px pb-40px">
              <itax-expense-list [expenditureColumnsHeader]="expenditureColumnsHeader"
                                 [expenditureColumnsData]="expenditureColumnsData"
                                 [indexData]="expenseHasChanged"
                                 (addMoreColumn)="addMoreColumn($event)"
                                 (onValueChanged)="onExpenseValueChanged($event)"
                                 (onSetCopyLength)="onSetCopyLength($event)"
                                 (resetColumnValue)="resetColumnValue($event)"
                                 (setNoRecalWht)="onNoRecalWht($event)"
                                 (checkHasEdit)="checkEmployeeHasAutoCal()"
                                 [copyLength]="copyLength"
                                 [defaultColumns]="defaultColumns"
                                 [defaultPndStl]="defaultPndStl"
                                 [isLoading]="isExcelLoading"
                                 [requestNotiList]="requestNotiList"
                                 [timeClockColumnList]="timeClockColumn.expense"
                                 [startRowIndex]="startRowIndex">
              </itax-expense-list>
            </div>
            <div class="bottom-summary">
              <itax-footer-list [expenditureColumns]="expenseFooter"
                                [expenseHasChanged]="autoCalColumn"
                                (resetAllInColumn)="resetAllInColumn()">
              </itax-footer-list>
            </div>
          </div>
          <div class="position-relative" *ngIf="totalData?.length > 0">
            <div class="d-grid w-100 position-relative pr-20px pb-40px">
              <itax-summary-list [totalData]="totalData" [isLoading]="isExcelLoading" [startRowIndex]="startRowIndex"></itax-summary-list>
            </div>
            <div class="bottom-summary">
              <itax-footer-list [summaryColumns]="summaryFooter"></itax-footer-list>
            </div>
          </div>
          <div class="position-relative" *ngIf="extendData?.length > 0">
            <div class="d-grid w-100 position-relative pr-20px pb-40px">
              <itax-extend-list 
                [extendColumns]="extendColumns"
                [extendData]="extendData" 
                [isLoading]="isExcelLoading" 
                [startRowIndex]="startRowIndex"
                (onValueChanged)="onExtendValueChanged($event)">
              </itax-extend-list>
            </div>
            <div class="bottom-summary"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="footer-btn">
    <div class="row">
      <div class="col text-danger d-flex align-items-center">
        <div class="pointer" (click)="handleResetPayroll($event, content)">Reset</div>
      </div>
      <div>
        <itax-paginator [total]="pageTotal" [(page)]="page" (pageChange)="onPageChange()"></itax-paginator>
      </div>
      <div class="col d-flex justify-content-end">
        <button type="button" class="btn btn-green-primary-no-border py-10px" (click)="onExport()">
          Export
        </button>
        <button type="button" class="btn btn-green-primary-no-border py-10px" (click)="saveDraft()">
          Save Draft
        </button>
        <button type="button" class="btn btn-primary py-10px px-40px ml-10px btn-confirm"
                (click)="handleConfirmPayroll()">
          Confirm
        </button>
      </div>
    </div>
  </div>
</div>
<div class="tab-content-left" [@tabState]="state">
  <div class="cross-btn pointer" (click)="onComeIn(null)">
    <itax-icon [name]="'close'" [color]="'#454c60'" [size]="'20px'"></itax-icon>
  </div>
  <div class="content" #wrapMiniProfile>
    <itax-mini-profile [employeeData]="employeeData"
                       [employeeDeductionData]="employeeDeductionData"
                       [hasPermissionViewSalary]="true"
                       [bgColor]="bgColor"
                       [companyId]="companyId"
                       (onViewProfile)="onViewProfile()"
                       (removeFormCurrentListToOld)="removeFormCurrentListToOld($event)"
                       [monthSelected]="month"
                       [yearSelected]="year">
    </itax-mini-profile>
  </div>
</div>
<ng-template #content>
  <itax-modal-confirm-reset (onHide)="modalRef.hide()"
                            (onAction)="confirmResetPayroll()"
                            [detail]="{
                              installment: installment,
                              month: month,
                              year: year,
                              companyId: companyId,
                              isInstallment: isInstallment
                            }"
                            >
  </itax-modal-confirm-reset>
</ng-template>
<ng-template #contentPayDate>
  <itax-modal-select-paydate [displayMonthTH]="displayMonthTH"
                             [month]="month"
                             [payDate]="payDate"
                             [installment]="installment"
                             [isInstallment]="isInstallment"
                             [year]="year"
                             (onHide)="modalRef.hide()"
                             (onAction)="onSetPayDate($event)">
  </itax-modal-select-paydate>
</ng-template>
<ng-template #contentAutoCal>
  <div class="modal-body p-30px">
    <div class="cross-btn pointer" (click)="modalRef.hide()">
      <itax-icon [name]="'close'" [color]="'#454c60'" [size]="'20px'"></itax-icon>
    </div>
    <div class="form-group">
      <label class="p1 font-weight-bold pb-20px mb-0 w-100">ให้ iTAX คำนวณรายการต่อไปนี้อัตโนมัติ:</label>
      <div class="mb-10px text-gray-medium" *ngFor="let item of checkListAutocal()">
        <itax-left-checkbox [id]="item.labelEn"
                            [label]="item.labelTh"
                            [checked]="item.isChecked"
                            (valueChange)="onCheckboxValueChange(item.type)">
        </itax-left-checkbox>
      </div>
    </div>
    <div class="w-100 d-flex justify-content-end mt-20px">
      <button type="button" class="btn btn-gray-no-border py-10px" (click)="cancelItaxcal()">
        Cancel
      </button>
      <button type="button" class="btn btn-primary py-10px px-60px ml-10px btn-ok" (click)="confirmItaxCal()">
        OK
      </button>
    </div>
  </div>
</ng-template>
<ng-template #contentWarning>
  <div class="modal-body p-30px">
    <div class="cross-btn pointer" (click)="modalRef.hide()">
      <itax-icon [name]="'close'" [color]="'#454c60'" [size]="'20px'"></itax-icon>
    </div>
    <div class="w-100 d-flex justify-content-center">
      <img src="../../../../../../assets/icons/ico-caution.svg">
    </div>
    <div class="p1 font-weight-bold my-10px text-center w-100">
      คุณยังกรอกข้อมูลต่อไปนี้ไม่ครบ:
    </div>
    <div class="w-100 d-flex justify-content-center text-gray-medium">
      <ul class="mb-0">
        <li class="pb-5px">
          ภาษีหัก ณ ที่จ่าย
        </li>
        <li class="pb-5px">
          ประกันสังคม
        </li>
        <li>
          กองทุนสำรองเลี้ยงชีพ
        </li>
      </ul>
    </div>
    <div class="p w-100 mt-20px text-gray-medium">
      โปรดตรวจสอบข้อมูลข้างต้น และกรอกให้ครบถ้วน หรือให้ iTAX คำนวณให้อัตโนมัติ โดยกดปุ่ม
      <i class="fa fa-undo-alt mr-5px text-primary"></i><span class="text-primary p">AUTOMATIC</span> ใต้คอลัมน์นั้นๆ
    </div>
    <div class="w-100 d-flex justify-content-end mt-20px">
      <button type="button" class="btn btn-primary py-10px px-60px ml-10px btn-ok" (click)="modalRef.hide()">
        กลับไปกรอกข้อมูล
      </button>
    </div>
  </div>
</ng-template>

<ng-template #progressModal>
  <div class="modal-body p-30px">
    <itax-progress-bar [hidden]="false"
                       [progress]="percentage">
    </itax-progress-bar>
  </div>
</ng-template>

<ng-template #confirmReportModal>
  <div class="modal-body p-30px">
    <div class="cross-btn pointer" (click)="modalRef.hide()">
      <itax-icon [name]="'close'" [color]="'#454c60'" [size]="'20px'"></itax-icon>
    </div>
    <div class="p1 font-weight-bold mb-10px">Download รายงาน</div>
    <div class="mb-20px">
      <itax-radio class="radio-padding"
        [items]="reportOptions"
        [selected]="selectedReportOption"
        (selectedChange)="onReportOptionChanged($event)">
      </itax-radio>
    </div>
    <div class="w-100 d-flex justify-content-end mt-30px">
      <button type="button" class="btn btn-gray-no-border py-10px px-30px" (click)="modalRef.hide()">
        Cancel
      </button>
      <button type="button" class="btn btn-primary py-10px px-40px ml-10px btn-download"
              (click)="downloadReport();" [disabled]="selectedReportOption == null">
        Download
      </button>
    </div>
  </div>
</ng-template>
